

<div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">Будь ласка підтвердіть Ваш email</h5>
    <button
            type="button"
            class="close"
            (click)="onClose()"
    >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
        </svg>
    </button>
</div>
<div class="modal-body">
        <input id="email" placeholder="Email" type="email" class="input" [(ngModel)]="email">

        <button class="email-login"
                [disabled]="!email.length"
                (click)="confirmEmail()">
            Увійти
        </button>
</div>
